import { render, staticRenderFns } from "./ApiErrorsReports.vue?vue&type=template&id=bec76dda&scoped=true&"
import script from "./ApiErrorsReports.vue?vue&type=script&lang=js&"
export * from "./ApiErrorsReports.vue?vue&type=script&lang=js&"
import style0 from "./ApiErrorsReports.vue?vue&type=style&index=0&id=bec76dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec76dda",
  null
  
)

export default component.exports